import Vue from "vue";
import PoprunMessage from "../mobile-pages/components/PoprunMessage.vue";
const MessageConstructor = Vue.extend(PoprunMessage);

let instance;

const showMessage = (options) => {
  if (!instance) {
    instance = new MessageConstructor({
      el: document.createElement("div"),
    });
    document.body.appendChild(instance.$el);
  }

  instance.show(options);
};

export default {
  info(message, options = {}) {
    showMessage({ type: "info", message, ...options });
  },
  success(message, options = {}) {
    showMessage({ type: "success", message, ...options });
  },
  warning(message, options = {}) {
    showMessage({ type: "warning", message, ...options });
  },
  error(message, options = {}) {
    showMessage({ type: "error", message, ...options });
  },
};
